import { StrictMode, VFC } from 'react'
import { Size } from '@opallabs/gem'
import {
  Button,
  ButtonIconPosition,
  ButtonSize,
  Icon,
} from '@opallabs/lapidary'
import * as styles from './styles'
import { NavigatorProps } from './types'

export type { NavigatorProps }

export const Navigator: VFC<NavigatorProps> = ({
  hasNext,
  hasPrevious,
  nextButtonLabel = 'Next',
  previousButtonLabel = 'Previous',
  onClickNext,
  onClickPrevious,
  onClickText,
  text,
  theme = 'light',
}) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  <StrictMode>
    <div css={styles.container}>
      <Button
        buttonText={previousButtonLabel}
        variant="ghost"
        disabled={!hasPrevious}
        hideButtonText={true}
        icon={
          <Icon
            ariaHidden
            height={Size.Icon}
            glyph="gem-chevron-w"
            width={Size.Icon}
          />
        }
        iconPosition={ButtonIconPosition.leading}
        name="toggle-visibility"
        onClick={onClickPrevious}
        size={ButtonSize.Small}
        styleOverrides={{
          button: styles.button({ theme }),
        }}
        theme={theme}
      />
      <span
        aria-live="polite"
        css={styles.text({
          clickable: Boolean(onClickText),
          theme,
        })}
        onClick={onClickText}
      >
        {text}
      </span>
      <Button
        buttonText={nextButtonLabel}
        variant="ghost"
        disabled={!hasNext}
        hideButtonText={true}
        icon={
          <Icon
            ariaHidden
            height={Size.Icon}
            glyph="gem-chevron-e"
            width={Size.Icon}
          />
        }
        iconPosition={ButtonIconPosition.leading}
        name="toggle-visibility"
        onClick={onClickNext}
        size={ButtonSize.Small}
        styleOverrides={{
          button: styles.button({ theme }),
        }}
        theme={theme}
      />
    </div>
  </StrictMode>
)
Navigator.displayName = 'Lapidary Unstable: Navigator ← ViewHeader'
